import React, { useState } from 'react';
import LinkPreview from './LinkPreview';

const ExpandableText = ({ content, isDarkMode, formatFn }) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = content && content.length > 800;
  const displayContent = isLong && !expanded ? content.slice(0, 800) : content;

  return (
    <>
      <div
        className="text-sm leading-snug whitespace-pre-line"
        dangerouslySetInnerHTML={{ __html: formatFn ? formatFn(displayContent || '') : (displayContent || '') }}
      />
      {isLong && !expanded && (
        <button
          onClick={(e) => { e.stopPropagation(); setExpanded(true); }}
          className="text-[#D4AF37] text-xs font-medium ml-1 hover:underline"
        >
          Read more
        </button>
      )}
      {(() => {
        const urlMatch = content?.match(/(https?:\/\/[^\s]+)/);
        return urlMatch ? <LinkPreview url={urlMatch[1]} isDarkMode={isDarkMode} /> : null;
      })()}
    </>
  );
};

export default ExpandableText;
